import { useState, useCallback } from 'react';

import formValidation from '../formValidation';
import { INITIAL_FILES_STATE, INITIAL_FORM_STATE, INITIAL_FORM_ERRORS } from '../config';

export const useTimelineForm = (createTimeline, updateTimeline, handleCloseModal, timelineMediaTypes) => {
    const [form, setForm] = useState(INITIAL_FORM_STATE);
    const [files, setFiles] = useState(INITIAL_FILES_STATE);
    const [errors, setErrors] = useState(INITIAL_FORM_ERRORS);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const handleInputChange = useCallback((name, value) => {
        setForm((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    }, []);

    const handleFileChange = useCallback((name, value) => {
        setFiles((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    }, []);

    const resetForm = useCallback(() => {
        setForm(INITIAL_FORM_STATE);
        setFiles(INITIAL_FILES_STATE);
        setErrors(INITIAL_FORM_ERRORS);
        setIsEdit(false);
        setSelectedItem(null);
    }, []);

    const setEditData = useCallback((item) => {
        setIsEdit(true);
        setSelectedItem(item);

        // Format the date for the HTML date input (YYYY-MM-DD)
        const formatDateForInput = (dateString) => {
            if (!dateString) return '';
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';
            return date.toISOString().split('T')[0];
        };
        const mediaType = timelineMediaTypes.find(type => type.id === item?.media_type_id);
        setForm({
            heading: item?.heading,
            event: item?.event,
            date: formatDateForInput(item?.date),
            url: item?.url,
            media_type_id: mediaType?.id,
        });
        setErrors(INITIAL_FORM_ERRORS);
        setFiles(INITIAL_FILES_STATE);
        // Note: Form data will be set by the modal component
    }, []);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        const isValid = formValidation(form, isEdit, files, setErrors, timelineMediaTypes);
        if (!isValid) {
            return;
        }
        const formData = new FormData();
        formData.append('date', form.date);
        formData.append('heading', form.heading);
        formData.append('event', form.event);
        formData.append('media_type_id', form.media_type_id);

        if (files.manual) {
            formData.append('manual', files.manual);
        }
        if (files.thumbnail) {
            formData.append('thumbnail', files.thumbnail);
        }
        if (form.url) {
            formData.append('url', form.url);
        }
        if (isEdit) {
            formData.append('id', selectedItem?.id);
            updateTimeline(formData, {
                onSuccess: () => {
                    handleCloseModal();
                }
            });
        } else {
            createTimeline(formData, {
                onSuccess: () => {
                    handleCloseModal();
                }
            });
        }

    }, [form, files, isEdit, selectedItem, updateTimeline, createTimeline, handleCloseModal]);

    return {
        form,
        files,
        errors,
        isEdit,
        selectedItem,
        handleInputChange,
        handleFileChange,
        resetForm,
        setEditData,
        setSelectedItem,
        handleSubmit
    };
}; 